import { render } from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=template&id=5f433335"
import script from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=script&lang=js"
export * from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=script&lang=js"
script.render = render

export default script